(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["fitroom-editorial-banner"] && !Shopify.designMode) return;
  try {
    
  if (!window.fitroomEditorialSoundToggleInitialized) {
    window.fitroomEditorialSoundToggleInitialized = true;

    document.addEventListener('click', (event) => {
      const button = event.target.closest('[data-fitroom-video-sound-toggle]');
      if (!button) return;

      const section = button.closest('[data-fitroom-editorial-banner]');
      const video = section?.querySelector('video');
      if (!video) return;

      video.muted = !video.muted;
      button.classList.toggle('is-sound-on', !video.muted);
      button.setAttribute('aria-pressed', String(!video.muted));
      button.setAttribute('aria-label', video.muted ? button.dataset.fitroomSoundOnLabel : button.dataset.fitroomSoundOffLabel);

      if (!video.muted) video.play();
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["fitroom-promo-banners"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('fitroom-app-carousel')) {
    customElements.define(
      'fitroom-app-carousel',
      class FitroomAppCarousel extends HTMLElement {
        connectedCallback() {
          this.mobileViewport = window.matchMedia('(max-width: 749px)');
          this.handleViewportChange = () => this.centerActivePreview();
          this.mobileViewport.addEventListener('change', this.handleViewportChange);

          this.centerActivePreview();

          if (document.readyState !== 'complete') {
            window.addEventListener('load', this.handleViewportChange, { once: true });
          }
        }

        disconnectedCallback() {
          this.mobileViewport?.removeEventListener('change', this.handleViewportChange);
          window.removeEventListener('load', this.handleViewportChange);
        }

        centerActivePreview() {
          if (!this.mobileViewport?.matches) return;

          requestAnimationFrame(() => {
            requestAnimationFrame(() => {
              const activePreview = this.querySelector('.fitroom-promos__app-preview--active');
              if (!activePreview) return;

              this.scrollLeft = activePreview.offsetLeft - (this.clientWidth - activePreview.offsetWidth) / 2;
            });
          });
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
